/* eslint-disable @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unused-vars */

import type BuildingDisplay from '@hoverinc/machete-core/build/display/index';
import type { AppearancePreset } from '@hoverinc/machete-core/build/feature-api/feature/AppearancePreset';

import type {
  AppearanceGroup,
  BuildingFeatureAppearances,
} from 'src/modules/designStudio/providers/SavedDesignsProvider/index';

const areFeatureAppearancePresetsEqual = (
  a: AppearancePreset,
  b: AppearancePreset,
): boolean => {
  if (a.appearanceType === b.appearanceType) {
    if (a.appearanceType === 'texture') {
      return (
        a.textureID === b.textureID &&
        a.variationUUID === b.variationUUID &&
        a.color === b.color
      );
    }
    if (a.appearanceType === 'procedural_mesh') {
      /**
       * Windows are the only procedural mesh's. Currently
       * we don't allow individual window appearance changes os this is okay but we need to iplement this correctly
       * in the future.
       */
      return true;
    }
  }
  return false;
};

const createOrAppendToAppearances = (
  appearances: AppearanceGroup[],
  appearance: AppearancePreset,
  uuid: string,
) => {
  const index = appearances.findIndex(a =>
    areFeatureAppearancePresetsEqual(a.appearance, appearance),
  );
  if (index === -1) {
    appearances.push({ appearance, uuids: [uuid] });
  } else {
    appearances[index].uuids.push(uuid);
  }
};

/**
 * Should this be implemented in machete? Is this an abstraction that would
 * be usefull to other clients?
 * - we are first grouping by primary label,
 * - secondly we are return the appearance and uuids
 *  - how we define appearance equality could be implementation specific?
 *    - texture & color, or just texture?
 *
 * one benefit is that testing that the api returns correctly can be tested in machete, can't
 * be tested as easily in web-react
 *
 * texturing doesnt group features in the same way, they group by primary & secondary label, so this is just usefull for web-react
 */
export const createBuildingAppearance = (
  display: BuildingDisplay | undefined,
): BuildingFeatureAppearances => {
  const appearances: BuildingFeatureAppearances = {
    walls: [],
    roofs: [],
    trims: [],
    windows: [],
    doors: {
      front: [],
      service: [],
      garage: [],
    },
  };

  if (!display) {
    return appearances;
  }

  return appearances;

  /*
  const { features } = display;

  features.forEach(feature => {
    const { uuid } = feature;
    const primaryLabelId = feature.primary_label;
    const appearance = feature.appearance_preset;

    if (Constants.WALL_LABELS.includes(primaryLabelId)) {
      createOrAppendToAppearances(appearances.walls, appearance, uuid);
    }

    if (primaryLabelId === Constants.ROOF_LABEL_ID) {
      createOrAppendToAppearances(appearances.roofs, appearance, uuid);
    }
    if (primaryLabelId === Constants.TRIM_LABEL_ID) {
      createOrAppendToAppearances(appearances.trims, appearance, uuid);
    }

    if (primaryLabelId === Constants.WINDOW_LABEL_ID) {
      createOrAppendToAppearances(appearances.windows, appearance, uuid);
    }
  });

  return appearances; */
};
